module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"zh-Hans":{"document-title":"产品介绍"},"zh-Hant":{}}')
  delete Component.options._Ctor
}
